import React from "react";
import Text from "../../common/Text";
import { REFERRAL_TERMS_HTML } from "../../../constants/referralTerms";

const Detail = ({ content }) => {
  return (
    <>
      <section className="detail_sec">
        <div className="contain">
          <Text string={content?.policy_text} />
          <Text string={REFERRAL_TERMS_HTML} />
        </div>
      </section>
    </>
  );
};

export default Detail;
